<script>
  import CommonFormElementMixin from './mixins/CommonFormElement'
  import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
  export default {
    mixins: [CommonFormElementMixin],
    props: {
      data: {
        type: Array
      }
    },
    mounted () {
      this.$refs.typeahead.inputValue = this.value
      this.typeahead = this.$refs.typeahead
    },
    data: () => ({
      typeahead: null,
      isFocused: false
    }),
    watch: {
      'typeahead.isFocused': function () {
        this.isFocused = this.typeahead.isFocused
      }
    },
    computed: {
      isLabelActive () {
        return this.isFocused || this.localValue
      }
    },
    components: {
      VueBootstrapTypeahead
    }
  }
</script>

<template>
  <div class="md-form">
    <label class="mr-5" :class="{ active: isLabelActive }">{{ label }}</label>
    <vue-bootstrap-typeahead
      v-model="localValue"
      :data="data"
      :minMatchingChars="1"
      :inputClass="error ? 'is-invalid' : ''"
      ref="typeahead"
    />
    <FormError v-if="error" :error="error" />
  </div>
</template>

<style lang="scss">
</style>


